import { EntityDetailsSimpleItem } from '../../../../../../ui/components/EntitySectionList';
import { LabelTypography } from '../../../../../../ui/components/LabelTypography';
import { useContactManagementTranslation } from '../../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Image } from '@juvare/platform-sdk-react/ui/components';
import { Box } from '@mui/material';
import React from 'react';
export const OrganizationTreeInfo = (props) => {
    var _a, _b, _c, _d;
    const { t } = useContactManagementTranslation();
    if (props.organization) {
        if (typeof props.organization !== 'string') {
            return (React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: themeColors.background,
                    p: 3,
                    gap: 2,
                    height: '100%',
                    overflow: 'auto',
                } },
                !props.hideHeader && (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1 } },
                    React.createElement(LabelTypography, { variant: 'h1' }, props.organization.name),
                    ((_a = props.organization.address) === null || _a === void 0 ? void 0 : _a.countyName) && (React.createElement(LabelTypography, { variant: 'body2' }, (_b = props.organization.address) === null || _b === void 0 ? void 0 : _b.countyName)))),
                props.organization.hasLogo && (React.createElement(Image, { entity: 'organization', entityId: props.id, attachmentKey: 'logo', alt: 'Logo', sx: { height: 180, maxWidth: 'fit-content', mb: 1 }, "data-test": 'organization-img' })),
                React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1 } },
                    React.createElement(LabelTypography, { variant: 'subtitle1' }, t('panels.organizations.organizationDetails.description')),
                    React.createElement(LabelTypography, { variant: 'body2', color: themeColors.text.subtle }, props.organization.description)),
                React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column' } },
                    React.createElement(LabelTypography, { sx: { mb: 1 }, variant: 'subtitle1' }, t('panels.organizations.organizationDetails.contact')),
                    React.createElement(EntityDetailsSimpleItem, { labelWidth: 130, label: t('panels.organizations.organizationDetails.name'), text: props.organization.contactName, textMaxWidth: 350, lineClamp: 2 }),
                    React.createElement(EntityDetailsSimpleItem, { labelWidth: 130, label: t('panels.organizations.organizationDetails.phone'), text: props.organization.contactPhoneNumber, textMaxWidth: 350 }),
                    React.createElement(EntityDetailsSimpleItem, { labelWidth: 130, label: t('panels.organizations.organizationDetails.email'), text: props.organization.contactEmail, textMaxWidth: 350 })),
                React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1 } },
                    React.createElement(LabelTypography, { variant: 'subtitle1' }, t('panels.organizations.organizationDetails.networks')),
                    React.createElement(LabelTypography, { variant: 'body2', color: themeColors.text.subtle }, (_d = (_c = props.organization.parentIds) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0))));
        }
        else {
            return React.createElement(LabelTypography, { variant: 'h6' }, props.organization);
        }
    }
    else {
        return null;
    }
};
